
/**
 * Returns `this`. Execute this without a "context" (i.e. without it being
 * attached to an object of the left-hand side), and `this` points to the
 * "global" scope of the current JS execution.
 */

module.exports = (function () { return this; })();



/*****************
 ** WEBPACK FOOTER
 ** ./~/global/index.js
 ** module id = 356
 ** module chunks = 7
 **/